
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/blog-posts/immediate-feedback-loop-raises-achievement-22",
      function () {
        return require("private-next-pages/c/blog-posts/immediate-feedback-loop-raises-achievement-22.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/blog-posts/immediate-feedback-loop-raises-achievement-22"])
      });
    }
  